import React, { ReactNode } from 'react';

import { Zone } from 'appAPITypes';

import CloseSvg from 'components/svg/picto/closeSvg';

const PhotographerZoneRow = ({
  zone,
  button,
}: {
  zone: Zone;
  button: ReactNode;
}) => {
  return (
    <li className="photograph-zones__label">
      {zone.name} - <small>{zone.zipcode}</small>
      {button}
    </li>
  );
};

const PhotographerZoneRows = ({
  zones,
  onZoneRemoveClick,
}: {
  zones: Zone[];
  onZoneRemoveClick: (zone: Zone, index: number) => void;
}) => (
  <>
    {zones.map((zone, index) => {
      return (
        <PhotographerZoneRow
          key={zone.id}
          zone={zone}
          button={
            <a
              className="photograph-zones__close"
              onClick={() => onZoneRemoveClick(zone, index)}
            >
              <CloseSvg />
            </a>
          }
        />
      );
    })}
  </>
);

export default PhotographerZoneRows;
